import React from "react";
import "./style.css"; // if you want footer-specific styles

/**
 * Props:
 *   raw: string   // the raw instruction text, e.g. "- Do A.- Do B.- Do C."
 */
export default function FormatInstructions({ raw }) {
  if (!raw) return null;

  // 1) Split on "- " and drop any empty pieces
  const parts = raw.split("- ").filter((piece) => piece.trim().length > 0);

  // 2) Render each instruction as a red bullet + text on its own line
  return (
    <div className="instruction-list">
      {parts.map((text, idx) => (
        <div key={idx} className="instruction-item">
          <span className="bullet-symbol">•</span>
          <span className="instruction-text">{text.trim()}</span>
        </div>
      ))}
    </div>
  );
}
